var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'category-item category-item__'+_vm.category.slug,style:({'backgroundColor':_vm.category.color, color: '#fff'})},[_vm._v(" "+_vm._s(_vm.category.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }